import { FinancialFilters, NumericFilters } from "../../../filters";
import { StringHelper } from '@bryntum/grid';
import Moment from "moment";
import { titleCase } from "../../../filters/string";
const xss = (a, ...b) => {
    // StringHelper.xss takes the values as rest arguments, passing the array
    // through as a single value silently drops every substitution after the first.
    //@ts-ignore
    return StringHelper.xss(a, ...b);
};
const age = {
    type: 'template',
    template: (data) => {
        if (!data.value) {
            return '';
        }
        return xss `${Moment().diff(data.value, 'days')}`;
    }
};
const date = {
    type: 'template',
    template: (data) => {
        if (!data.value) {
            return '';
        }
        return xss `${Moment(data.value).format('D/M/Y')}`;
    }
};
const daysSince = {
    type: 'template',
    template: (data) => {
        if (!data.value) {
            return '';
        }
        return xss `${Moment().diff(data.value, 'days')} days`;
    }
};
const link = {
    type: 'template',
    template: (data) => xss `<a href="#" style="font-weight: 500;">${data.value}</a>`,
};
const image = {
    type: 'template',
    template: (data) => {
        if (data.value) {
            return `<div style="width: 64px; padding-top: 5px; padding-bottom: 5px;">
                <img src="${data.value}" srcset="${data.value.replace('_dimensions_', 'w128')} 128w,${data.value.replace('_dimensions_', 'w256')} 256w,${data.value.replace('_dimensions_', 'w512')} 512w" style="display: block; width: 64px; height: auto; border-radius: 3px;">
            </div>`;
        }
        return `<div style="width: 64px; padding-top: 5px; padding-bottom: 5px; color: #999; text-align: center;"><span class="material-icons-outlined">no_photography</span></div>`;
    }
};
const vrm = {
    type: 'template',
    template: (data) => xss `<span class="registration small">${data.value}</span>`
};
const vehicleDescription = {
    type: 'template',
    template: (data) => `<div><div>${data.record.title}</div><div style="font-size: .8rem; color: #999;">${data.record.vehicle.derivative}</div></div>`
};
const label = {
    type: 'template',
    template: (data) => xss `<span class="badge badge-secondary" style="border-radius: 0;">${data.value}</span>`
};
const prettyText = {
    type: 'template',
    template: (data) => xss `${titleCase(data.value)}`
};
const isPopulatedCheck = {
    type: 'template',
    width: 100,
    align: 'center',
    template: (data) => {
        const isSet = !!data.value;
        const isSetString = isSet && typeof data.value === 'string' && data.value.length > 0;
        const isSetNumber = isSet && typeof data.value === 'number' && data.value > 1;
        const isSetBoolean = isSet && typeof data.value === 'boolean';
        if (isSetNumber || isSetString || isSetBoolean) {
            return xss `<span class="material-icons" style="color: #12c457;">check</span>`;
        }
        return '';
    }
};
const roundedCurrency = {
    type: 'template',
    template: (data) => data.value > 0 ? FinancialFilters.currency(data.value) : ''
};
const number = {
    type: 'template',
    template: (data) => data.value > 0 ? NumericFilters.formatNumber(data.value, 0) : ''
};
const percentage = {
    type: 'template',
    template: (data) => data.value > 0 ? NumericFilters.formatNumber(data.value, 2) + '%' : ''
};
const roundedCurrencyWithPence = {
    type: 'template',
    template: (data) => data.value > 0 ? FinancialFilters.currency(data.value, 2) : ''
};
const summaryRoundedCurrencyWithPence = {
    summaryRenderer: ({ sum }) => `£${NumericFilters.formatNumber(sum, 2)}`,
};
const colouredSignedAmount = {
    type: 'template',
    template: (data) => {
        if (data.value > 0) {
            return `<span style="color: #12c457;">+${FinancialFilters.currency(data.value)}</span>`;
        }
        else if (data.value < 0) {
            return `<span style="color: red;">${FinancialFilters.currency(data.value)}</span>`;
        }
        return '';
    }
};
const summaryAverage = {
    sum: 'average',
    summaryRenderer: ({ sum }) => `Avg: ${Math.round(sum)}`
};
const summaryAverageMoney = {
    sum: 'average',
    summaryRenderer: ({ sum }) => `Avg: £${Math.round(sum)}`
};
const summaryAveragePercentage = {
    sum: 'average',
    summaryRenderer: ({ sum }) => `Avg: ${sum.toFixed(1)}%`
};
const summaryAverageDays = {
    sum: 'average',
    summaryRenderer: ({ sum }) => `Avg: ${Math.round(sum)} days`
};
export { age, date, daysSince, link, image, vrm, vehicleDescription, label, isPopulatedCheck, roundedCurrency, number, percentage, roundedCurrencyWithPence, summaryRoundedCurrencyWithPence, colouredSignedAmount, prettyText, xss, summaryAverage, summaryAverageDays, summaryAverageMoney, summaryAveragePercentage, };
